import { render, staticRenderFns } from "./UserListPop.vue?vue&type=template&id=52d5f6b0&"
import script from "./UserListPop.vue?vue&type=script&lang=js&"
export * from "./UserListPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports